export { useBackendConnection } from './use-backend-connection'
export { useSession, useIdGenerator } from './use-session'
export { useContentTabs, type ContentTab, type ContentTabType } from './use-content-tabs'
export { useConversationHistory } from './use-conversation-history'
export { useResizable } from './use-resizable'
export { useShellChatAside } from './use-shell-chat-aside'
export { useFileVersions } from './use-file-versions'

// Chat hook — Vercel AI SDK v6 with native tool calling via SSE stream interception
export { useChat } from './use-chat'

// ADO integration hooks
export { useAdoAuth, type AdoAuthError, type AdoAuthErrorType } from './use-ado-auth'
export {
  useAdoProjects,
  useAdoAreaPaths,
  useAdoIterations,
  searchAdoIdentities,
  type AdoProject,
  type AdoIdentity,
} from './use-ado-meta'